/**
 * useInLocalStorageTTL
 * This hook is used to check if a value is in local storage with a time-to-live (TTL) feature.
 *
 * @param key - The key under which the value is stored in local storage.
 */
export const useInLocalStorageTTL = (key: string | undefined) => {
  if (!key) {
    return false;
  }

  const item = window.localStorage.getItem(key);

  if (!item) {
    return false;
  }

  const { expiry } = JSON.parse(item);
  return expiry >= Date.now();
};
